import React, { useEffect, useState } from "react";
import { Card, Button } from "react-bootstrap";
import GoogleMapReact from 'google-map-react';
import Settings from "@/common/Settings";
import PinComponent from "@/components/Common/PinComponent";
import LeafletSingleMap from "@/components/core/LeafletSingleMap";
import { useVisitsPreferences } from "@/hooks/useLocalStorage";
import { useTranslation } from "react-i18next";

const VisitMap = (props) => {
  const { t } = useTranslation();
  const [model, setModel] = useState(props.model);
  const { mapProvider } = useVisitsPreferences();
  const GoogleMapRef = React.createRef();
  const [theMap, setTheMap] = useState(null);
  const [theMapsReference, setTheMapsReference] = useState(null);
  const [zoom, setZoom] = useState(19);

  const handleApiLoaded = (map, mapsReference) => {
    setTheMap(map);
    setTheMapsReference(mapsReference);
  };

  const getFullAddress = (model) => {
    let address = model.address || "";
    if (model.address2) address += ", " + model.address2;
    if (model.sector) address += ", " + model.sector;
    if (model.city) address += ", " + model.city;
    if (model.region) address += ", " + model.region;
    if (model.country) address += ", " + model.country;
    return address;
  };

  useEffect(() => {
    setModel(props.model);
  }, [props.model]);

  if (mapProvider === "osm") {
    return <LeafletSingleMap model={model} />;
  }

  return (
    <Card className="shadow-sm border rounded-3 overflow-hidden">
      <Card.Header className="bg-white py-2 px-3 d-flex align-items-center justify-content-between border-bottom">
        <h6 className="fw-bold mb-0 text-dark">
          <i className="fas fa-map-location-dot me-2 text-primary" />
          {t("Ubicación en Mapa")}
        </h6>
        <Button
          variant="outline-primary"
          size="sm"
          className="py-1 px-2 rounded-3"
          style={{ fontSize: "0.78rem" }}
          onClick={() => {
            const fullAddress = `${model.latitude},${model.longitude}`;
            window.open(
              `https://www.google.com/maps/search/?api=1&query=${fullAddress}`,
              "MapWindow",
              "width=1280,height=840"
            );
          }}
        >
          <i className="fas fa-up-right-from-square me-1" />
          {t("Abrir en Google Maps")}
        </Button>
      </Card.Header>
      <Card.Body className="p-0" style={{ height: "340px", position: "relative" }}>
        <GoogleMapReact
          ref={GoogleMapRef}
          yesIWantToUseGoogleMapApiInternals={true}
          onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
          bootstrapURLKeys={{ key: Settings.GoogleMapsKey }}
          style={{ width: "100%", height: "100%", position: "relative" }}
          center={{ lat: Number(model.latitude), lng: Number(model.longitude) }}
          defaultZoom={zoom}
        >
          {model.longitude && (
            <PinComponent
              Type={"Visit"}
              lat={Number(model.latitude)}
              item={model}
              lng={Number(model.longitude)}
              text={model.name}
            />
          )}
        </GoogleMapReact>
      </Card.Body>
      <Card.Footer className="bg-light py-2 px-3 text-muted small border-top">
        <i className="fas fa-location-dot me-2 text-danger" />
        {getFullAddress(model) || t("Sin dirección registrada")}
      </Card.Footer>
    </Card>
  );
};

export default VisitMap;
